// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-beacon-and-runway-taxiway-lights.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-beacon-and-runway-taxiway-lights/aerodrome-beacon-and-runway-taxiway-lights.js';

mount([g0]);
